
import { Component, OnInit, Input, AfterViewInit, OnDestroy  } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { FormControl, FormGroup, Validators, FormGroupDirective, NgForm} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { DialogsService } from '../dialogs/dialogs.service';
import { MatSnackBar } from '@angular/material';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { PortalService } from '../services/portal.service';
import { ToastrService } from 'ngx-toastr';
import { ValidateService } from '../common/validate.service';
import { SharedService} from '../common/shared.service';
import { TopnavService } from '../header/topnav/topnav.service';
import {Observable} from 'rxjs/Observable';

import {
  Ng4FilesService,
  Ng4FilesConfig,
  Ng4FilesStatus,
  Ng4FilesSelected
} from '../ng4-files';
//import { HttpClient } from '@angular/common/http';
import {ErrorStateMatcher} from '@angular/material/core';

export class StateMatcherValidator implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Feedback Form - /feedbackform
 **/
@Component({
  selector: 'gosg-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit, AfterViewInit, OnDestroy {
  submitMsg: any;

  @Input() state:string;
  @Input() getEmail;
  @Input() getFullname;

  objMediaType: any;
  public feedbackFormgrp: FormGroup;
  feedback_message: FormControl;
  agency_name: FormControl;
  feedbacktype: FormControl;
  nama_penuh: FormControl;
  feedbacksubject: FormControl;
  mediaFile: FormControl;
  email: FormControl;
  @Input() sendMsg;
  isAdmin = false;
  fullName:string;
  emaiL:string;
  icNo:string;
  languageId; //= this.languageId;
  resultdata :any=[];
  typeFb: any[];
  subjectFb = [];
  public filteredSubjectFb: any;
  private subscriptionLang: ISubscription;
  loading:boolean = false;
  selFile: any;
  chkUploadFile: any;
  resFileExtn = [];
  filesResult : any;
  selectedFile;
  fileSelected;
  selFiles = [];
  showImg = false;
  mediaPath = "images";
  fileToUpload: File = null;
  imgUpload: any;

  private sharedConfig: Ng4FilesConfig = {
    //acceptExtensions: ['png','jpg', 'jpeg','pdf', 'doc', 'mp4'],
    acceptExtensions: ['*'],
    maxFilesCount: 1,
    maxFileSize: 1024,
    totalFilesSize: 1024
    //maxFileSize: 10737418240,
    //totalFilesSize: 10737418240
    //maxFileSize: 2097152,
    //totalFilesSize: 2097152
  };
  private fileSizeLimit: any;
  public matcher: StateMatcherValidator;

  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };

  lang;
  resetMsg;
  selectedFiles;
  private IsExceedSize: boolean;
  private uploadSettings: any;
  public msgFileType: string;
  public msgFileSize: string;

  private registerInfo: any;
  private serviceList: any;

  public totalWords: number;

  filteredOptions: Observable<string[]>;

  constructor(
    private ng4FilesService: Ng4FilesService, 
    public snackBar: MatSnackBar,
    private dialogsService: DialogsService,
    private translate: TranslateService,
    private portalService:PortalService,
    private validateService:ValidateService,
    private toastr: ToastrService,
    private sharedService :SharedService,
    private topnavservice: TopnavService,
    private route: ActivatedRoute
  ) {


    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
        const myLang = translate.currentLang;
        if (myLang == 'en') {
          translate.get('HOME').subscribe((res: any) => {
              this.lang = 'en';
              this.languageId = 1;
          });
    
        }
        if (myLang == 'ms') {
          translate.get('HOME').subscribe((res: any) => {
              this.lang = 'ms';
              this.languageId = 2;
          });
        }

        if(this.topnavservice.flagLang){
          this.totalWords = 0;
          this.subjectFb = [];
          this.filteredSubjectFb = [];
          this.getFileTypeSettings(this.languageId,()=>{});
          this.getSubType();
          this.getTypenSubject();
          setTimeout(()=>{
            if (this.registerInfo && this.registerInfo.fullName) {
              this.feedbackFormgrp.get('nama_penuh').setValue(this.registerInfo.fullName);
              this.feedbackFormgrp.get('email').setValue(this.registerInfo.email);
              this.setRegisterInfo();
              //this.registerInfo = null;
              localStorage.setItem('registerinfo', null);
            }  
          }, 500);
        }

        setTimeout(()=>{
          this.translate.get('pageTitle.home').subscribe((title:string) => {
            title = title + this.translate.instant('home.breadcrumb.feedback');
            this.sharedService.setTitle(title);
          }); 
        },500);
        
      });

      this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
        this.fontSize = data;
        $('.mat-input-placeholder').css('font-size', this.fontSize.sizeS);
      });

      this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
        this.fontType = data;
        $('.mat-select-value-text span').css('font-family', this.fontType);
      });

      this.matcher = new StateMatcherValidator();
    }
    

    ngOnDestroy() {
      this.subscriptionLang.unsubscribe();
      this.subscriptionFontSize.unsubscribe();
      this.subscriptionFontType.unsubscribe();
      this.matcher = null;
    }

    loadLimitConf(callback) {
      this.portalService.getLocalConfig().subscribe(data => {
        if (data) {
          if (data.limit.filesize) {
            this.fileSizeLimit = data.limit.filesize; 
          }
          callback();
        }
       },
       error => {
         console.log(error);
         callback();
       });
    }

    getErrorMessage() {
      return this.email.hasError('required') ? this.translate.instant('register.err.email') :
          this.email.hasError('pattern') ? this.translate.instant('register.pattern.email') :
              '';
    }
    
    ngOnInit() {
      if(!this.languageId){
        if (localStorage.getItem('langID')) {
          this.languageId = localStorage.getItem('langID');
        } else {
          this.languageId = 1;
        }  
      }else{
        this.languageId = 1;
      }

      this.getFileTypeSettings(this.languageId,() => {
        if (this.uploadSettings) {
          this.msgFileSize = this.formatBytes(this.uploadSettings.feedbackFileSize, 0);
          console.log(this.msgFileSize);
          this.sharedConfig.maxFileSize = parseInt(this.uploadSettings.feedbackFileSize);
          this.sharedConfig.totalFilesSize = parseInt(this.uploadSettings.feedbackFileSize);
          this.sharedConfig.acceptExtensions = this.uploadSettings.feedbackFileType.replace(/\s/g, '').toLowerCase().split(',');
          this.ng4FilesService.addConfig(this.sharedConfig);
        }
      });

      this.route.params.subscribe(params => {
        if (params['id']) {
            console.log(params['id']);
            this.languageId = params['id'];
            if (this.languageId === '1') {
                this.translate.setDefaultLang('en');
                this.translate.use('en');
            } else {
                this.translate.setDefaultLang('ms');
                this.translate.use('ms');
            }
           
        } else if (localStorage.getItem('langID')) {
            this.languageId = localStorage.getItem('langID');
        } else {
            this.languageId = 1;
        }
        this.getFileTypeSettings(this.languageId, ()=> {});
      });
        this.checkLog();
   
        this.getTypenSubject();
        this.mediaFile = new FormControl();
        this.feedback_message = new FormControl('', [Validators.required]),
        this.agency_name = new FormControl(''),
        this.feedbacktype = new FormControl('', [Validators.required]),
        this.feedbacksubject = new FormControl('', [Validators.required]),
        this.formCtrl();
        this.feedbackFormgrp = new FormGroup({
            nama_penuh: this.nama_penuh,
            mediaFile: this.mediaFile,
            feedback_message: this.feedback_message,
            agency_name: this.agency_name,
            email: this.email,
            feedbacktype: this.feedbacktype,
            feedbacksubject: this.feedbacksubject,
        
        });     
    }

    ngAfterViewInit() {
     
      // Get Title and Sent to GA
    	this.translate.get('pageTitle.home').subscribe((title:string) => {
        title = title + this.translate.instant('home.breadcrumb.feedback');
        this.sharedService.setTitleAndGtag(title);
      }); 

      this.sharedService.loadFontSizeData();
      this.sharedService.loadFontTypeData();
      if (localStorage.getItem('registerinfo')) {
        this.registerInfo = JSON.parse(localStorage.getItem('registerinfo'));
        console.log(this.registerInfo);
       
        setTimeout(()=>{
          if (this.registerInfo && this.registerInfo.fullName) {
            this.feedbackFormgrp.get('nama_penuh').setValue(this.registerInfo.fullName);
            this.feedbackFormgrp.get('email').setValue(this.registerInfo.email);
            this.setRegisterInfo();
            //this.registerInfo = null;
            localStorage.setItem('registerinfo', null);
          }
        }, 500);
      }

    }

    filterDropDown(keyword) {
    
      let anotherArray = JSON.parse(JSON.stringify(this.subjectFb)); 
      this.filteredSubjectFb = anotherArray.filter((f) =>{ return f.feedbackSubcategoryDescription.toLowerCase().startsWith(keyword.toLowerCase())});
       //this.filteredSubjectFb = anotherArray.filter((f) =>{ return f.feedbackSubcategoryDescription.toLowerCase().indexOf(keyword.toLowerCase()) > -1});
      if (this.filteredSubjectFb.length == 0) {
        this.filteredSubjectFb = anotherArray.filter((f) => { 
          return f.feedbackSubcategoryDescription.toLowerCase().split(/[\s,\?\,\.!]+/).some(w=> w.startsWith(keyword.toLowerCase()));
        });
      }
       console.log(this.filteredSubjectFb);
    }

    resetSubjectFilter() {
      this.filteredSubjectFb = JSON.parse(JSON.stringify(this.subjectFb));
    }

    setRegisterInfo() {
      if (!this.registerInfo && !this.registerInfo.identificationNo) {
        return;
      }
      let header;
      if (this.languageId==2) {
        header = 'Masalah Pendaftaran Yang Tidak Berjaya.\n\nMaklumat pendaftaran:\n';
      } else {
        header = 'Unsuccessful Registration Problem.\n\nRegistration information:\n';
      } 
      let info = header;
        info += this.translate.instant('register.label.nameplh') + ': ' + this.registerInfo.fullName + '\n';
        info += this.translate.instant('register.label.ic') + ': ' + this.registerInfo.identificationNo + '\n';
        info += this.translate.instant('register.label.email') + ': ' + this.registerInfo.email + '\n';
        info += this.translate.instant('register.label.tel') + ': ' + this.registerInfo.phoneNo.replace('*','');
      this.feedbackFormgrp.get('feedback_message').setValue(info);
    }

    charCount(name) {
      if (name) {
          return name.replace(/ /g,"").length;
      } else {
          return 0;
      }
   }

   limitKeypress(event, value, maxLength) {
    let newValue =  value.replace(/ /g,"");
    if (newValue && newValue.length >= maxLength) {
        event.preventDefault();
    }
  }

  onKey(event) {
    let words = event.target.value;
    let isLimit = this.wordsCounter(words);
    //console.log('isLimit:', isLimit);
    if (!isLimit) {
      $('#feedback_message').val(words.substring(0, words.length - 1));
      return false;
    } else {
      return true;
    }
  }

  wordsCounter(content): boolean {
    let words = content.replace(/\s+/g, ' ').split(' '); //content.split(/\s+/);
    //console.log(words); 
    let num_words = words.length; 
    let max_limit=500;
    if(num_words>max_limit){
      return false;
    } else {
      if (words[words.length-1] !== '') {
        this.totalWords = num_words; 
      } else {
        this.totalWords = num_words-1; 
      }     
      return true;
    }
  }


    
    /*getUserData(){
          if(localStorage.getItem('fullname')){
            this.feedbackFormgrp.get('nama_penuh').setValue(localStorage.getItem('fullname'));
            this.feedbackFormgrp.get('nama_penuh').disable();
          }else{
            this.feedbackFormgrp.get('nama_penuh').enable();
          }

          if(localStorage.getItem('email')){
            this.feedbackFormgrp.get('email').setValue(localStorage.getItem('email'));
            this.feedbackFormgrp.get('email').disable();
          }else{
            this.feedbackFormgrp.get('email').enable();
          }
    }; */

    validateCtrlChk(ctrl: FormControl) {
      // return ctrl.valid || ctrl.untouched
      return this.validateService.validateCtrl(ctrl);
    }
    
    formCtrl(){
      if(this.isAdmin == false){
        this.nama_penuh = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern(2,80).name)]),            
        this.email = new FormControl('', [Validators.required, Validators.pattern(this.validateService.getPattern().email)])
      }
      if(this.isAdmin == true){
        this.nama_penuh = new FormControl(),                  
        this.email = new FormControl()
      }
    }

    checkLog(){
      let value:string = localStorage.getItem('usrID');
      if(value != null){
        this.isAdmin = true;
        this.fullName = localStorage.getItem('name');
        this.emaiL = localStorage.getItem('email');
        this.icNo = localStorage.getItem('icNo');
      }
      else{
        this.isAdmin = false;
      }
      // 
    }

    formatBytes(bytes, decimals) {
      if(bytes == 0) return '0 Bytes';
      var k = 1024,
          dm = decimals <= 0 ? 0 : decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + '' + sizes[i];
   }
    
    getSubType(){
      this.feedbacksubject.reset();
      this.feedbacktype.reset();
      this.resetForm();
      
    }

    getFileTypeSettings(lang, callback) {

      if (!lang) {
        lang = this.languageId;
      }
      
      this.loading = true;
      this.portalService.feedbacksettings(lang)
        .subscribe(data => {
          //let dataUC;
          // console.log(data.feedbackFileType);
          //dataUC = data.feedbackFileType.toUpperCase();
          //this.ng4FilesService.getConfig().acceptExtensions = data.feedbackFileType+', '+data.feedbackFileType.toUpperCase();
          // console.log(this.ng4FilesService.getConfig().acceptExtensions);
          this.sharedService.errorHandling(data, ()=> {
              this.uploadSettings = data;
              this.msgFileType = this.uploadSettings.feedbackFileType;
              this.loading = false;
              callback();
          });
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');    
          this.loading = false;
          callback();             
        });

    }

    getTypenSubject(){
      this.loading = true;
      this.portalService.feedbacktype(this.languageId)
        .subscribe(data => {
          this.sharedService.errorHandling(data, (function(){
            this.typeFb  = data;
          }).bind(this));  
          this.loading = false;
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');    
          this.loading = false;             
        });
    
      
    }

    getCategoryDetail(categoryCode){
      this.loading = true;
      this.feedbackFormgrp.get('feedbacksubject').setValue(null);
      if (categoryCode==100) {
        this.getDigitalServices();
        return;
      }
      this.portalService.feedbacksubject(categoryCode, this.languageId)
      .subscribe(data => {
        this.sharedService.errorHandling(data, (function(){
           console.log('data', data);
           if (data.length==0) {
             let list = [];
             list.push({ 'id': null, 'feedbackSubcategoryCode': 0, 'feedbackSubcategoryDescription': '-' })
             this.subjectFb = list;
             this.filteredSubjectFb = list;
             this.feedbackFormgrp.get('feedbacksubject').setValue(0);
           } else {
            this.subjectFb  = data;
            this.filteredSubjectFb = this.subjectFb; //JSON.parse(JSON.stringify(this.subjectFb.sort((a, b) => a["feedbackSubcategoryDescription"].localeCompare(b["feedbackSubcategoryDescription"], undefined, {sensitivity: 'base'}))));//JSON.parse(JSON.stringify(this.subjectFb)).sort(this.predicateBy("feedbackSubcategoryDescription"));      
            
          }
                
          }).bind(this));  
          this.loading = false;
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
          this.loading = false;           
        });
       
    }

    predicateBy(prop) {
      return function (a, b) {
         if (a[prop] > b[prop]) {
              return 1;
          } else if (a[prop] < b[prop]) {
              return -1;
          }
          return 0;
         
        }
      //this.imageList.sort((a, b) => a[sortColumn].localeCompare(b[sortColumn], undefined, {sensitivity: 'base'}));
    }

    getDigitalServices() {

      this.loading = true;
      this.portalService.getDigitalServices(this.languageId)
      .subscribe(data => {
        this.sharedService.errorHandling(data, (function(){
          this.data = data.list;
          console.log('datasampai', this.data);
          this.serviceList = this.data.reduce((reduceData,obj) => 
          { 
            return reduceData.concat(obj.details); 
          }, []);
          console.log('this.serviceList', this.serviceList);
          //const getServicesList = a => (result => (a.reduce((reduceData, obj) => (result.push({ 'id': obj.id, 'feedbackSubcategoryCode':obj.code, 'feedbackSubcategoryDescription': obj.title }))), result))([]);
          //this.serviceList.sort((a, b) => a.feedbackSubcategoryDescription < b.feedbackSubcategoryDescription ? -1 : (a.feedbackSubcategoryDescription > b.feedbackSubcategoryDescription ? 1 : 0))
          let getServicesList = this.serviceList.reduce(function(pV, cV){
            pV.push({ 'id': cV.id, 'feedbackSubcategoryCode':cV.code, 'feedbackSubcategoryDescription': cV.title })
            return pV;
          }, []);
 
          let serviceList = getServicesList; //getServicesList(this.serviceList);
          console.log('data after reduce', serviceList);
          this.subjectFb  = serviceList;
          this.filteredSubjectFb =  JSON.parse(JSON.stringify(this.subjectFb.sort((a, b) => a["feedbackSubcategoryDescription"].localeCompare(b["feedbackSubcategoryDescription"], undefined, {sensitivity: 'base'}))));           
          }).bind(this));  
          this.loading = false;
        },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
          this.loading = false;           
        });

    }
   
    openSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
        duration: 9000
      });
    }

  filesSelect(selectedFiles: Ng4FilesSelected, lan): void {
    {
      this.imgUpload = selectedFiles.files[0].name;
      console.log(this.ng4FilesService.getConfig());
      console.log({ 'selectedFiles': selectedFiles });
      // selectedFiles.files[0].name = selectedFiles.files[0].name.toLowerCase();
      console.log({ 'selectedFiles': selectedFiles.files[0].name.toLowerCase() });

      console.log({ 'selectedFiles.status': selectedFiles.status });
      console.log({ 'Ng4FilesStatus.STATUS_SUCCESS': Ng4FilesStatus.STATUS_SUCCESS });

      //this.IsExceedSize = false;

      if (selectedFiles.status !== Ng4FilesStatus.STATUS_SUCCESS) {
        if (selectedFiles.status == Ng4FilesStatus.STATUS_MAX_FILE_SIZE_EXCEED) {
          this.selectedFile = selectedFiles.status;
          this.sharedService.showError(this.uploadSettings.feedbackFileSizeError, '');
        } else if (selectedFiles.status == Ng4FilesStatus.STATUS_NOT_MATCH_EXTENSIONS) {
          console.log({ 'selectedFiles.status': selectedFiles.status });
          console.log({ 'Ng4FilesStatus.STATUS_NOT_MATCH_EXTENSIONS ': Ng4FilesStatus.STATUS_NOT_MATCH_EXTENSIONS });
          this.sharedService.showError(this.uploadSettings.feedbackFileExtensionError, '');
        } else {
          this.sharedService.showError(this.uploadSettings.feedbackFileUploadError, '');
        }

        this.selectedFile = selectedFiles.status;
        return;

        //if (!this.IsExceedSize) {
        //  this.selectedFile = selectedFiles.status;
        //  return;
        //}
      }



      this.feedbackFormgrp.controls.mediaFile.setValue(selectedFiles.files[0].name);
      this.selectedFile = Array.from(selectedFiles.files).map(file => file.name);
      this.fileSelected = selectedFiles.files[0];

      console.log({ 'fileSelect': this.fileSelected });

      this.selFiles = [];
      this.selFiles.push(selectedFiles);
    }

  }

    submitForm(formValues:any){

      if(formValues.feedback_message && this.wordsCounter(formValues.feedback_message)==false ) {
        this.sharedService.showError(this.translate.instant('feedback.maxworderr'),'');
        return;
      }

      if (this.IsExceedSize) {
        this.sharedService.showError(this.translate.instant('feedback.maxsizerror'),'');
        return;
      }

      let body = {
        "feedbackName":null,
        "feedbackEmail":null,
        "feedbackType":null,
        "feedbackMessage": null,
        "feedbackSubject":null,
        "language":null
        //"feedbackActionBy":null
      };

      body.feedbackName = formValues.nama_penuh;
      body.feedbackEmail = formValues.email;
      body.feedbackType = { "feedbackCategoryCode": formValues.feedbacktype };
      body.feedbackSubject = { "feedbackSubcategoryCode": formValues.feedbacksubject };
      if (!formValues.agency_name || formValues.agency_name.trim().length == 0) {
        body.feedbackMessage = formValues.feedback_message;
      } else {
        body.feedbackMessage = this.translate.instant('feedback.label.agency2') + ': '+formValues.agency_name+'\n'+this.translate.instant('feedback.label.comment') +':\n'+formValues.feedback_message;
      } 

      console.log(body.feedbackMessage);
    
      body.language =  { "languageId": this.languageId};
      
      let datasend = JSON.stringify(body); 
      let formData: FormData = new FormData();

      console.log({'fileSelected':this.fileSelected});

      if(this.selFiles.length != 0) {
          console.log({'selFiles':this.selFiles});
          formData.append('mediaFile', this.selFiles[0].files[0], this.selFiles[0].files[0].name);
      } else {
        //formData.append('mediaFile', null, null);
      }

      formData.append('feedbackData', datasend);
         
      if(this.isAdmin){
        
        console.log('admin');
        
        body.feedbackName = "NNN";
        //body.feedbackActionBy = {"id": this.icNo }
        body.feedbackEmail = "TEST@yopmail.com";
        datasend =JSON.stringify(body); 
        
      this.loading = true;
      
        this.portalService.feedback(formData,this.languageId).subscribe(
          data => {

            this.sharedService.errorHandling(data, (function(){         
              this.resetForm();
              this.registerInfo = null;        
              this.sharedService.showSuccess(this.translate.instant('feedback.msgsubmit'), '');     
            }).bind(this));  
            this.loading = false;
          },
          error => {
            console.log(error);
            if (error.status == 502) {
              this.sharedService.showError(this.translate.instant('feedback.maxsizerror'), ''); 
            } else if (error.status == 0)  {
                this.sharedService.showError(this.translate.instant('feedback.connreseterror'), '');    
            } else {
              this.sharedService.showError('Unhandled Error:'+ error.status, ''); 
            }
            this.loading = false;         
          });

      } else{
        // console.log({'formData':formData['feedbackData']});
        
        // console.log('x admin');
        
      this.loading = true;

        this.portalService.feedback(formData, this.languageId).subscribe(
          data => {

            this.sharedService.errorHandling(data, (function(){
              this.resetForm();
              this.registerInfo = null;  
              this.sharedService.showSuccess(this.translate.instant('feedback.msgsubmit'), '');            
          }).bind(this));  
          this.loading = false;
        },
        error => {
          console.log(error);
          if (error.status == 502) {
            this.sharedService.showError(this.translate.instant('feedback.maxsizerror'), ''); 
          } else if (error.status == 0)  {
              this.sharedService.showError(this.translate.instant('feedback.connreseterror'), '');    
          } else {
            this.sharedService.showError('Unhandled Error:'+ error.status, ''); 
          }
          this.loading = false;
        });
      }
    }

  showResetMsg(){
    this.dialogsService
    .confirm('', this.translate.instant('feedback.reset'))
    .subscribe(
      data => {
        if(data){
          this.resetForm();
        }
      });
  }

  resetForm(){
    this.totalWords = 0;
    this.subjectFb = [];
    this.filteredSubjectFb = [];
    this.nama_penuh.reset();
    this.feedback_message.reset();
    this.email.reset();
    this.feedbacksubject.reset();
    this.feedbacktype.reset();
    this.agency_name.reset();
    this.resetMedia();
    this.sendMsg = true;
    
  }

  resetMedia() {
    this.mediaFile.reset();
    this.selFiles = [];
    this.IsExceedSize = false;
    this.imgUpload ='';
  }

  resetMethod(event) {
    this.resetForm();
    this.resetMedia();
  }

}


// WEBPACK FOOTER //
// ./src/app/feedback/feedback.component.ts